<template>
    <div class="px-4">
        <div class="row">
            <div class="col-sm-5">
                <DropDownVue :disabledOnselect="disabled"
                             :icon="icons.check"
                             :items="items"
                             :label="titles.Functionaly"
                             :validate="$v.packCountryDomainFunctionality.functionality.id"
                             @changeItems="handleChangeDropDown"
                             @method="handleChangeDropDown"
                             inputKey="functionality"
                             itemKey="id"
                             itemValue="label"
                />
            </div>
            <div :class="col">
                <Textarea :disabled=true
                          :inputKey="'details'"
                          :name="titles.Details"
                          :validate="$v.packCountryDomainFunctionality.functionality.details">

                </Textarea>
            </div>
            <div class="col-sm-2" v-if="packCountryDomainFunctionality.functionality.hasValue==true">
                <Input :inputKey="'value'"
                       :name="titles.Value"
                       :validate="$v.packCountryDomainFunctionality.value"
                       @method="getValue"
                />
            </div>
            <div class="col-sm-1 for-delete-functionality">
                <a @click="addFunctionality()" type="button" v-if="selectedFunctionality">
                    <i class="fas fa-check font-20 text-success"></i>
                </a>
                <a @click="deleteFunctionality()" type="button">
                    <i class="fas fa-times font-20 text-danger"></i>
                </a>
            </div>
        </div>

        <div class="displayed col-sm-6">
            <CheckBox
                    :inputKey="'isDisplayed'" :name="titles.displayed"
                    :validate="packCountryDomainFunctionality.isDisplayed"
                    @method="getValue"/>
        </div>
    </div>
</template>

<script>
    import {titles} from '../../../utils/general/titles';
    import {icons} from '../../../utils/general/icons';
    import DropDownVue from '../../common/DropDownVue';
    import Input from '../../common/Input';
    import Textarea from '../../common/Textarea.vue';
    import {required} from 'vuelidate/lib/validators';
    import {packCountryDomainFunctionality} from '../models/packCountryDomainFunctionality';
    import CheckBox from '../../common/CheckBox';


    export default {
        name: 'NewLineFunctionality',
        components: {
            DropDownVue,
            Input,
            Textarea,
            CheckBox
        },
        props: {
            items: Array,
            keyForm: Number,
            disabled: Boolean,
            valuePack: String
        },
        data() {
            return {
                titles,
                icons,
                packCountryDomainFunctionality: packCountryDomainFunctionality(),
                value: this.valuePack,
                col: 'col-sm-6',
                selectedFunctionality: false
            };
        },
        created() {
            this.getDisabledFunctionality();
        },
        updated() {
            this.getDisabledFunctionality();
        },
        methods: {
            getDisabledFunctionality() {
                if (this.disabled == true) {
                    this.packCountryDomainFunctionality.value = this.valuePack;
                    this.packCountryDomainFunctionality.functionality = this.items[0];
                    this.packCountryDomainFunctionality.functionality.hasValue == false ||
                    this.packCountryDomainFunctionality.functionality.hasValue == undefined ?
                        this.col = 'col-sm-6' : this.col = 'col-sm-4';
                }
            },
            deleteFunctionality() {
                this.$emit('deleteFunctionality');
            },
            addFunctionality() {
                if (this.packCountryDomainFunctionality.functionality.hasValue) {
                    this.$v.$touch();
                    if (this.$v.$invalid) {
                        return;
                    }
                }
                this.packCountryDomainFunctionality.packCountryDomain = this.$cookies.get('pack');
                this.$emit('addFunctionality', this.packCountryDomainFunctionality);
            },
            handleChangeDropDown(val, inputKey) {
                this.packCountryDomainFunctionality[inputKey] = val ? val : this.packCountryDomainFunctionality[inputKey];
                this.packCountryDomainFunctionality[inputKey].hasValue == false ?
                    this.col = 'col-sm-6' : this.col = 'col-sm-4';
                if (val != null) {
                    this.selectedFunctionality = true;
                } else {
                    this.selectedFunctionality = false;
                    this.$v.packCountryDomainFunctionality.functionality.details.$model = null;
                }
                this.packCountryDomainFunctionality['value'] = null;
            },
            getValue(inputKey, val) {
                this.$v.packCountryDomainFunctionality[inputKey].$touch();
                this.packCountryDomainFunctionality[inputKey] = val;
            },
        },
        watch: {
            items() {
                this.packCountryDomainFunctionality = packCountryDomainFunctionality();
            },
            disabled(NewVal) {
                this.disabledOnselect = NewVal;
            },
            valuePack(NewVal) {
                this.packCountryDomainFunctionality.value = NewVal;
            }
        },
        validations: {
            packCountryDomainFunctionality: {
                functionality: {
                    id: {required},
                    label: {},
                    details: {required},
                },
                value: {required},
                isDisplayed: {}
            }
        }
    };
</script>

<style scoped>
    /deep/ .selectNotEmpty {
        margin-top: -2%;
        display: table-cell !important;
    }

    @media (max-width: 1180px) {
        /deep/ .selectIconNotEmpty {
            margin-top: -10%;
            margin-left: -10%;
        }

        /deep/ .selectEmpty {
            display: flex !important;
            margin-top: 8%;
        }

        /deep/ .selectIconEmpty {
            margin-left: -10% !important;
        }

        /* .selectEmpty {
             margin-top: 10%!important;
         }*/
    }

    @media (max-width: 1092px) {
        /deep/ .selectIconNotEmpty {
            margin-top: 0% !important;
            margin-left: -20% !important;
        }
    }

    @media (max-width: 735px) {
        /deep/ .selectIconNotEmpty {
            margin-top: 0% !important;
            margin-left: -38% !important;
        }

        /deep/ .selectIconEmpty {
            margin-left: -20% !important;
        }

        /deep/ .selectEmpty {
            display: flex !important;
            margin-top: 14% !important;
        }
    }

    @media (max-width: 576px) {
        /deep/ .selectNotEmpty {
            margin-top: -2% !important;
        }

        /deep/ .selectIconNotEmpty {
            margin-top: -13% !important;
            margin-left: -98% !important;
        }

        /deep/ .selectEmpty {
            display: flex !important;
            margin-top: -10% !important;
        }

        /deep/ .selectIconEmpty {
            margin-left: -96% !important;
        }

        /deep/ .sm1 {
            padding-left: 0 !important;
            margin-top: -9% !important;
            margin-left: 98% !important;
        }
    }

    .md-textarea {
        overflow: hidden !important;
    }

    /deep/ .mdTextAreaNotEmpty {
        margin-top: 2%;
    }
    .displayed{
        padding-top: 2%;
    }
</style>
